function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import SettingsItem from '../../../SettingsItem';
import SectionTitle from '../../../SectionTitle';
import { IconStyle, IconType } from './components';
import { slideMotion } from './motion';

var MetricSettings = function MetricSettings(_ref) {
  var widgetSettings = _ref.widgetSettings,
      chartSettings = _ref.chartSettings,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      hiddenOptions = _ref.hiddenOptions;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement("div", null, React.createElement(SectionTitle, {
    title: t('widget_customization_metric_settings.title')
  }), !(hiddenOptions === null || hiddenOptions === void 0 ? void 0 : hiddenOptions.card) && React.createElement(SettingsItem, {
    id: "metric-card",
    label: t('widget_customization_card_settings.label'),
    isEnabled: widgetSettings.card.enabled,
    onChange: function onChange(cardEnabled) {
      onUpdateWidgetSettings(_objectSpread(_objectSpread({}, widgetSettings), {}, {
        card: _objectSpread(_objectSpread({}, widgetSettings.card), {}, {
          enabled: cardEnabled
        })
      }));
    }
  }), React.createElement(SettingsItem, {
    id: "display-icon",
    label: t('widget_customization_metric_settings.display_icon'),
    isEnabled: chartSettings.iconEnabled,
    onChange: function onChange(iconEnabled) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        iconEnabled: iconEnabled
      }));
    }
  }), React.createElement(AnimatePresence, {
    initial: false
  }, chartSettings.iconEnabled && React.createElement(motion.div, Object.assign({}, slideMotion, {
    style: {
      overflow: 'hidden'
    }
  }), React.createElement(IconStyle, {
    iconStyle: chartSettings.iconStyle,
    onChange: function onChange(iconStyle) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        iconStyle: iconStyle
      }));
    }
  }), React.createElement(IconType, {
    iconType: chartSettings.iconType,
    onChange: function onChange(iconType) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        iconType: iconType
      }));
    }
  }))));
};

export default MetricSettings;